module.exports = __webpack_public_path__ + "static/jamrichova-35660f458050134bcbd3b4acdce34c92.jpg";